import { useAdminHref } from '../../helpers';
import styles from '../index.module.scss';
import { Link } from 'react-router-dom';
import React, { FC } from 'react';
import classNames from 'classnames';

interface IProps {
  url: string;
  label: string;
  isActive: boolean;
}

export const Tab: FC<IProps> = (props: IProps) => {
  const { url, label, isActive } = props;
  const href = useAdminHref(url);

  return (
    <Link
      to={href}
      className={classNames(styles.tab, {
        [styles.isActive]: isActive
      })}
    >
      {label}
    </Link>
  );
};

export default Tab;
